import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'app/services/config.service';

@Component({
  selector: 'contact-block-banner',
  templateUrl: './contact-block-banner.component.html',
  standalone: false,
})
export class ContactBlockBannerComponent implements OnInit {
  title: string = '';
  description: string = '';
  link: any[] = [];

  constructor(public router: Router, private configService: ConfigService) {}

  ngOnInit(): void {
    this.configService.getConfig('contact-block').subscribe((response) => {
      const contact = response?.Items?.[0]?.contact?.[0];
      if (contact) {
        this.title = contact.title;
        this.description = contact.description;
        this.link = contact.link || [];
      } else {
        this.title = '';
        this.description = '';
        this.link = [];
      }
    });
  }

  onActionButtonClick(event: Event): void {
    const path =
      typeof event.composedPath === 'function'
        ? event.composedPath()
        : event.target
          ? [event.target]
          : [];
    const isActionButton = path.some(
      (el) =>
        el instanceof Element &&
        (el.tagName.toLowerCase() === 'wp-inline-button' || el.classList.contains('action-button'))
    );
    if (isActionButton) {
      const url = this.link[0]?.path;
      if (url) {
        this.router.navigate([url]);
      }
    }
  }
}
